import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  type UpdateHunterPrerequisiteItemRequest,
  putHunterUserIDPrerequisites,
} from "Infrastructure/Api/Api";
import { hunterPrerequisitesKeys } from "Api/Queries/Hunter/useHunterPrerequisitesQuery";
import { huntersListKeys } from "Api/Queries/User/useHuntersListQuery";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type MutationPayload = {
  userID: number;
  items: Array<UpdateHunterPrerequisiteItemRequest>;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useUpdateHunterPrerequisitesMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, MutationPayload>({
    mutationFn: processResponseWithApiProblemDetails(
      ({ userID, items }: MutationPayload) =>
        putHunterUserIDPrerequisites(items, userID),
    ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: hunterPrerequisitesKeys.byUserID(variables.userID),
      });
      queryClient.invalidateQueries({
        queryKey: hunterPrerequisitesKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: huntersListKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
